import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

function onboardingRoutes(): RouteRecordRaw[] {
  return [
    {
      redirect: { name: ROUTE_NAMES.ONBOARDING.HOME },
      name: ROUTE_NAMES.ONBOARDING.INDEX,
      path: '/bo-seller/onboarding',
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
    // It cannot be a child of the onboarding route because the index doesnt have component
    {
      name: ROUTE_NAMES.ONBOARDING.HOME,
      component: () => import('./onboarding/pages/Home.vue'),
      path: '/bo-seller/onboarding/home',
      meta: {
        autonomousBannerPageName: 'onboarding-home',
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}

const routes = (): RouteRecordRaw[] => {
  return [
    ...onboardingRoutes(),
    {
      redirect: { name: ROUTE_NAMES.BADOOM.DOCUSIGN_CGU },
      name: ROUTE_NAMES.DOCUSIGN_CGU,
      path: '/bo-seller/merchant/cgu/sign',
      meta: {
        owners: ['bot-squad-seller-experience-front'],
      },
    },
    {
      name: ROUTE_NAMES.HOME.INDEX,
      component: () => import('./boarded/pages/Home.vue'),
      path: '/bo-seller',
      meta: {
        autonomousBannerPageName: 'home',
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}

export default routes
